<div class="app-container">
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>

  <div class="app-footer-container">
    <!-- <ss-footer></ss-footer> -->
    <lcp-footer></lcp-footer>
  </div>
</div>
